import axios from "axios"
import useSWR from "swr"

/**
 * Fetcher standar:
 * - Mengambil endpoint + params, mengembalikan res.data.data
 * - Harap backend mengembalikan bentuk:
 *   { data: { data: [...], links: [...], from, to, total, ... } }
 */
const fetcher = async (url, params) => {
  const { data } = await axios.get(url, { params })
  return data
}

/**
 * Hook daftar Stock Transfer (paginated).
 * Param umum yang didukung (sesuaikan dengan backend-mu):
 * - page, search
 * - name   : bisa dipakai utk filter reference_id (opsional)
 * - from   : outlet asal
 * - to     : outlet tujuan
 * - order_by, direction
 */
const useStockTransferRepositories = (params) => {
  const baseUrl = `${process.env.REACT_APP_INVENTORY_API_URL}/stock/transfer`

  const { data, error, mutate, isValidating } = useSWR(
    [baseUrl, params],
    fetcher
  )

  return {
    data,                         // berisi objek pagination: { data:[], links, from, to, total, ... }
    isLoading: !error && !data,
    error,
    isValidating,
    mutate
  }
}

export default useStockTransferRepositories
